import React from 'react';
import { Languages } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleToggle = () => {
    const newLanguage = language === 'en' ? 'zh' : 'en';
    setLanguage(newLanguage);
  };

  return (
    <button
      onClick={handleToggle}
      className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg text-white hover:bg-white/20 transition-all duration-200"
      aria-label="Toggle language"
    >
      <Languages className="w-4 h-4" />
      <span className="font-medium">
        {language === 'en' ? '中文' : 'English'}
      </span>
    </button>
  );
};

export default React.memo(LanguageToggle);